import { Pie, PieChart, Tooltip } from 'recharts'
import Card from 'react-bootstrap/Card'
import PropTypes from 'prop-types'
import Spinner from './Spinner'
import styles from '../styles/TypeDistributionPanel.module.scss'
import useDarkMode from 'use-dark-mode'

const TypeDistributionPanel = ({ content, isLoading, title }) => {
  const darkMode = useDarkMode(false)
  return (
    <>
      <h5 className='title'>{title || 'Average Type Distribution'}</h5>
      <Card className='shadow-sm'>
        <Card.Body className={styles.body}>
          {isLoading ? (
            <Spinner className='fa-2x' />
          ) : content ? (
            <PieChart height={238} width={320}>
              <Pie
                data={content.map(({ color, label, value }) => ({
                  fill: color,
                  label,
                  value,
                }))}
                dataKey='value'
                endAngle={90}
                isAnimationActive={false}
                label={({
                  cx,
                  cy,
                  midAngle,
                  innerRadius,
                  outerRadius,
                  value,
                  index,
                }) => {
                  const RADIAN = Math.PI / 180
                  const radius = 25 + innerRadius + (outerRadius - innerRadius)
                  const x = cx + radius * Math.cos(-midAngle * RADIAN)
                  const y = cy + radius * Math.sin(-midAngle * RADIAN)
                  return (
                    <text
                      dominantBaseline='central'
                      fill={content[index].color}
                      fontSize={10}
                      textAnchor={x > cx ? 'start' : 'end'}
                      x={x}
                      y={y}
                    >
                      {content[index].label} ({value})
                    </text>
                  )
                }}
                nameKey='label'
                outerRadius={80}
                startAngle={450}
              />
              <Tooltip
                contentStyle={{ background: darkMode.value ? '#000' : '#fff' }}
              />
            </PieChart>
          ) : (
            <div className={styles.noData}>No data</div>
          )}
        </Card.Body>
      </Card>
    </>
  )
}

TypeDistributionPanel.propTypes = {
  content: PropTypes.arrayOf(
    PropTypes.shape({
      color: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
    })
  ),
  isLoading: PropTypes.bool.isRequired,
  title: PropTypes.string,
}

export default TypeDistributionPanel
